module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-5.866690eb.png";